import {useClientsContext} from '../hooks/useClientsContext'
import {useEffect, useState} from 'react'
import {useAuthContext} from "../hooks/useAuthContext"
import '../styling/ClientList.css'
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../config.js';


const ClientList = ({updateCurrentClient}) => {

  const navigate = useNavigate();

  const {clients, dispatch} = useClientsContext();

  const {user} = useAuthContext();

  const handleAccessClick = (client) => {
    updateCurrentClient(client)
  };

  useEffect(() => {
    const fetchClients = async () => {

        const response = await fetch(`${API_BASE_URL}/api/client`, {
            headers: {"Authorization": `Bearer ${user.token}`}
        })

        const json = await response.json()

        if(response.ok){
            dispatch({type: "SET_CLIENTS", payload:json})
        }     
    }
    if (user){
        fetchClients()
    }  

// add clients to dependency below to update deleted client. //
  }, [dispatch,user])

    return ( 

        <div className="clientlist">
            <div className="overflow-x-auto">
  <table className="table">
    {/* head */}
    <thead>
      <tr>
        <th>
          <label>
            
          </label>
        </th>
        <th>Name</th>
        <th>Property</th>
        <th>Contact</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      {/* row 1 */}

      {clients && clients.map((client) => {
  return (
    <tr key={client._id}>
      <th>
        <label>
          
        </label>
      </th>
      <td>
        <div className="flex items-center gap-3">
          <div className="avatar">
            <div className="mask mask-squircle w-12 h-12">
            </div>
          </div>
          <div>
            <div className="font-bold">{client.clientFirst} {client.clientLast}</div>
            <div className="text-sm opacity-50">{client.clientCountry}</div>
          </div>
        </div>
      </td>
      <td>
        {client.clientStreet1} {client.clientStreet2} {client.clientCity} {client.clientState}
      </td>
      <td>{client.clientPhone}</td>
      <th>
      <button className="btn btn-success" id="accessbutton" style={{color:'white'}} onClick={() => handleAccessClick(client)}>
        Select Client
      </button>
      </th>
    </tr>
  );
})}


     
      </tbody>
    
  </table>
</div>
        </div>

    );
}
 
export default ClientList;